import type { Dependency } from '@wendellhu/redi';
import { SolutionController } from './solution.controller';
import { SolutionService } from './solution.service';
import { ISolutionRepository } from './interfaces/solution.repository.interface';
import { SolutionRepository } from './repositories/solution.repository';
import { ISolutionApplicationService } from './interfaces/solution-application-service.interface';

export const SolutionBackendModule = {
  providers: [
    [SolutionController],
    [SolutionService],
    [ISolutionRepository, { useClass: SolutionRepository }],
    [ISolutionApplicationService, { useClass: SolutionService }],
  ] satisfies Dependency[],
  imports: [],
};
